export const getRaffleListSelector = (state: any): any => state.userRaffleStore.ticketTiers;
export const getRaffleLoadingSelector = (state: any): any => state.userRaffleStore.isLoading;
